import { isSuccess, Result } from '@carvana/merch-result';
import { useContext, useEffect } from 'react';
import { httpWithAuth } from '~/clients';
import { getTrades } from '~/constants/endpoints';
import StaticContext from '~/context/common/StaticContext';
import TradeContext from '~/context/common/TradeContext';
import AcquisitionSummary from '~/contracts/common/Trade';
import { MerchUiTradeResponse } from '~/pages/api/trades/v1/get';
import generateErrorLogger from '~/utilities/errorHandlers';

async function getMerchTrades(
  correlationId: string
): Promise<AcquisitionSummary[]> {
  const url = getTrades({ currentPageUrl: window.location.href });
  const { data } = await httpWithAuth.get<Result<MerchUiTradeResponse>>(url, {
    headers: {
      'x-client-id': 'e902dfb1-f373-450d-8cca-9db2e12bfce5',
      'x-correlation-id': correlationId
    }
  });

  if (isSuccess(data)) {
    return data.content.trades;
  }

  return [];
}

export default function useGetTrades(isLoggedIn: boolean) {
  const {
    trades: { setLoading, setData, setError }
  } = useContext(TradeContext);
  const { eventCorrelationId } = useContext(StaticContext);

  useEffect(() => {
    if (!isLoggedIn) return;

    setLoading();
    getMerchTrades(eventCorrelationId)
      .then(t => setData(t))
      .catch(generateErrorLogger('Get trades', {}, { callback: setError }));
  }, [eventCorrelationId, isLoggedIn, setData, setError, setLoading]);
}
